// removed by extract-text-webpack-plugin
module.exports = {"header":"Dialog__header","body":"Dialog__body","footer":"Dialog__footer","space-between":"Dialog__space-between","spaceBetween":"Dialog__space-between","center":"Dialog__center","error-title":"Dialog__error-title","errorTitle":"Dialog__error-title","error-icon":"Dialog__error-icon","errorIcon":"Dialog__error-icon"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Dialog/Dialog.css
// module id = 1139
// module chunks = 8